import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Checkbox from './checkbox';

import styles from '../styles/uikitInputsCheckboxSet.module.scss';

const CheckboxSet = ({
  fieldId,
  className = '',
  onChange = () => {},
  testId = '',
  options = [],
  fieldKey,
  fieldValues = [],
  isStacked = false,
}) => {
  if (!options?.length) return null;

  const updateValues = (value, checked) => {
    let newFieldValues = fieldValues;
    if (newFieldValues.includes(value)) {
      if (!checked) {
        newFieldValues = newFieldValues.filter((v) => v !== value);
      }
    } else if (checked) {
      newFieldValues.push(value);
    }
    onChange(newFieldValues);
  };

  return (
    <div
      className={classnames(styles.element, { [styles.isStacked]: isStacked }, className)}
      id={fieldId}
      role="group"
      aria-labelledby={`${fieldId}-label`}
    >
      {options.map((option, index) => {
        const checkboxId = `${fieldId}-${index}`;
        const handleChange = (checked) => {
          updateValues(option.value, checked);
        };

        return (
          <Checkbox
            id={checkboxId}
            value={option.value}
            label={option.label}
            isDisabled={option.isDisabled}
            onChange={handleChange}
            testId={testId}
            fieldKey={fieldKey}
            isInSet
            isChecked={fieldValues.includes(option.value)}
            key={checkboxId}
          />
        );
      })}
    </div>
  );
};

CheckboxSet.propTypes = {
  fieldId: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  testId: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      isChecked: PropTypes.bool,
    }),
  ),
  fieldKey: PropTypes.string.isRequired,
  fieldValues: PropTypes.arrayOf(PropTypes.string),
  isStacked: PropTypes.bool,
};

export { CheckboxSet as CheckboxSetStorybook };
export default React.memo(CheckboxSet);
